import { nullOrEmpty } from "@/util/utils"

const PROVINCES_DB = require("@/assets/raw/provinces.json")

/**
 * Static lookup utility for resolving Spanish postal codes to province and city names.
 * Province data is loaded from a bundled JSON; per-province postal-code files are
 * lazy-loaded via `require()` using the first two digits of the zip code.
 */
export default class ZipCodeDB {
  /**
   * Dynamically loads the postal-code dataset for the given two-digit province code.
   * @param {number} provinceCode - Two-digit Spanish province code (e.g. `28` for Madrid).
   * @returns {object[]} Array of postal-code records for that province.
   * @throws Will throw if no JSON file exists for `provinceCode`.
   */
  static __importProvinceFile(provinceCode) {
    return require(`@/assets/raw/postal_codes-provinces/${provinceCode}.json`)
  }

  /**
   * Resolves a Spanish postal code to its matching province and city names.
   * A single zip code can map to multiple localities (INE entities), so an array is returned.
   * @param {string|number} zipCode - 5-digit Spanish postal code.
   * @returns {Array<{ province: string, city: string }>|null}
   *   Array of matching province/city pairs, or `null` if the zip code is unknown.
   */
  static getProvinceAndCityName(zipCode) {
    let codes
    try {
      codes = this.__importProvinceFile(parseInt(zipCode.toString().substr(0, 2)))
    } catch (e) {
      return null
    }

    const zipCodeInfo = codes.filter(x => x["COD_POSTAL"] === parseInt(zipCode))

    if (nullOrEmpty(zipCodeInfo)) {
      return null
    }

    const provinceName = PROVINCES_DB.filter(x => parseInt(x["CODIGO"]) === zipCodeInfo[0]["COD_PROVINCIA"])[0]["LITERAL"]

    return zipCodeInfo.map(x => ({ province: provinceName, city: x["LocalidadMunicipio_INE"] }))
  }

}